import {ModalElementTypes, AlertTypes, ModalActions} from 'enums/api';
import {IUser} from 'types/user';

export interface BaseResponse {
  display_duration_seconds: number | null;
  display_element: ModalElementTypes;
  display_level: AlertTypes;
  display_message: string;
  display_title?: string;
  massage?: string;
  error?: string;
  redirect?: string;
  display_button_text?: string;
  display_button_action?: ModalActions;
}

export interface WithToken extends BaseResponse {
  access_token: string;
  user: IUser;
}

// Function that checks if object is a valid BaseResponse (returns boolean)
export function isValidBaseResponse(obj: any): obj is BaseResponse {
  return (
    obj &&
    typeof obj === "object" &&
    "display_element" in obj &&
    "display_level" in obj &&
    "display_message" in obj
  );
}
